<!--
 * @Author: xuchen
 * @Date: 2020-03-11 14:19:25
 * @Desc: 监控点
 -->

<template>
  <div class="wonitor-resource-info flex flex-column">
    <div class="panel-tit flex items-center justify-between">
      <div class="flex items-center">
        <span>监控点 ({{ selectedMonitorKeys.length }} / {{ dataProvider.length }})</span>
      </div>
      <i
        :class="[isFold ? 'h-icon-angle_up' : 'h-icon-angle_down', 'arrow-icon']"
        @click="handleFold"
      ></i>
    </div>
    <div v-show="!isFold" class="content">
      <ul>
        <li
          v-for="item in dataProvider"
          :key="item.monitorId"
          :class="[
            'monitor-point-item flex justify-between items-center',
            { 'actived-item': selectedMonitorKeys.indexOf(item.monitorCode) !== -1 }
          ]"
          @click="handleVideoAction(item.monitorCode)"
        >
          <div class="flex items-center">
            <i class="monitor-point-icon monitor-icon"></i>
            <span v-ellipsis class="monitor-point-name">{{ item.monitorName }}</span>
          </div>
          <i
            v-if="selectedMonitorKeys.indexOf(item.monitorCode) !== -1"
            class="monitor-point-icon stop-icon"
          ></i>
          <i v-else class="monitor-point-icon start-icon"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { _debounce } from '@/utils/commonUtil'
export default {
  name: 'MonitorPoint',
  props: {
    dataProvider: {
      // 监测点信息
      type: Array,
      default: () => []
    },
    selectedMonitorKeys: {
      // 选择的监控点主键
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isFold: false // 是否折叠
    }
  },
  watch: {
    dataProvider(data) {
      if (data && data.length) {
        // 默认选中第一个监控点
        this.handleVideoAction(data[0].monitorCode)
      }
    }
  },
  methods: {
    /**
     * @author xuchen
     * @date 2020-03-03 17:37:09
     * @desc 折叠操作
     */
    handleFold() {
      this.isFold = !this.isFold
    },

    /**
     * @author xuchen
     * @date 2020-03-11 16:26:46
     * @desc 选择监控点播放/停止
     */
    handleVideoAction: _debounce(function(key) {
      // 切换监控源
      if (this.selectedMonitorKeys.indexOf(key) === -1) {
        this.$emit('handleStartVideo', key)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.wonitor-resource-info {
  height: 100%;
  .panel-tit {
    height: 32px;
    line-height: 32px;
    padding-left: 8px;
    padding-right: 6px;
    background: rgba(0, 0, 0, 0.08);
  }
  .arrow-icon {
    font-size: 16px;
    cursor: pointer;
  }
  .content {
    padding: 15px 12px;
  }
  .monitor-point-item {
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding: 0 5px;
    color: rgba(0, 0, 0, 0.7);
    cursor: pointer;
    &:hover {
      color: #fff;
      background-color: #e72528;
    }
    &.actived-item {
      color: #fff;
      background-color: #e72528;
      .monitor-icon {
        background: url('~@/assets/images/enterpriseVideoInspection/monitor_point_actived.png')
          no-repeat;
      }
    }
    .items-center {
      width: 90%;
      .monitor-point-name {
        width: 60%;
      }
    }
    .monitor-point-icon {
      display: inline-block;
      width: 24px;
      height: 24px;
    }
    .monitor-icon {
      margin-right: 8px;
      background: url('~@/assets/images/enterpriseVideoInspection/monitor_point.png') no-repeat;
    }
    .start-icon {
      background: url('~@/assets/images/enterpriseVideoInspection/start.png') no-repeat;
    }
    .stop-icon {
      background: url('~@/assets/images/enterpriseVideoInspection/stop.png') no-repeat;
    }
  }
}
</style>
